"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./polyfills/element-closest");

var _componentLayerManager = require("@doordash/component-layer-manager");

var _ModalContent = _interopRequireWildcard(require("./ModalContent"));

var _styles = require("./styles");

var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));

var _componentOverlay = _interopRequireDefault(require("@doordash/component-overlay"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ScrollLock = _interopRequireDefault(require("./ScrollLock"));

var _designLanguage = require("@doordash/design-language");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// Only allow outside clicks within <ModalFooter>
var allowClicksOutsideFocusTrap = function allowClicksOutsideFocusTrap(e) {
  var modalFooter = e.target.closest("#".concat(_ModalContent.MODAL_FOOTER_ID));
  return Boolean(modalFooter);
};

var ModalPositioner = function ModalPositioner(_ref) {
  var shouldAnimate = _ref.shouldAnimate,
      props = _objectWithoutProperties(_ref, ["shouldAnimate"]);

  if (shouldAnimate) {
    return /*#__PURE__*/_react["default"].createElement(_componentLayerManager.LayerAnimations.SlideDown, _extends({
      component: _styles.FillScreen
    }, props));
  }

  return /*#__PURE__*/_react["default"].createElement(_componentLayerManager.LayerAnimations.None, _extends({
    component: _styles.FillScreen
  }, props));
};

ModalPositioner.propTypes = {
  shouldAnimate: _propTypes["default"].bool.isRequired
};

var FillScreen = function FillScreen(_ref2) {
  var shouldAnimate = _ref2.shouldAnimate,
      props = _objectWithoutProperties(_ref2, ["shouldAnimate"]);

  if (shouldAnimate) {
    return /*#__PURE__*/_react["default"].createElement(_componentLayerManager.LayerAnimations.Fade, _extends({
      component: _styles.FillScreen
    }, props));
  }

  return /*#__PURE__*/_react["default"].createElement(_componentLayerManager.LayerAnimations.None, _extends({
    component: _styles.FillScreen
  }, props));
};

FillScreen.propTypes = {
  shouldAnimate: _propTypes["default"].bool.isRequired
};

var Modal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Modal, _React$PureComponent);

  var _super = _createSuper(Modal);

  function Modal() {
    _classCallCheck(this, Modal);

    return _super.apply(this, arguments);
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onEnterComplete = _this$props.onEnterComplete,
          onCloseComplete = _this$props.onCloseComplete,
          inProp = _this$props["in"],
          shouldCloseOnOverlayClick = _this$props.shouldCloseOnOverlayClick,
          shouldAnimate = _this$props.shouldAnimate,
          shouldCloseOnEscapePress = _this$props.shouldCloseOnEscapePress,
          props = _objectWithoutProperties(_this$props, ["onEnterComplete", "onCloseComplete", "in", "shouldCloseOnOverlayClick", "shouldAnimate", "shouldCloseOnEscapePress"]);

      return /*#__PURE__*/_react["default"].createElement(_styles.FillScreen, null, /*#__PURE__*/_react["default"].createElement(FillScreen, {
        "in": inProp,
        shouldAnimate: shouldAnimate
      }, /*#__PURE__*/_react["default"].createElement(_styles.OverlayPositioner, null, /*#__PURE__*/_react["default"].createElement(_componentOverlay["default"], {
        isVisible: true,
        onClick: shouldCloseOnOverlayClick ? this.props.onClose : null
      }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(ModalPositioner, {
        "in": inProp,
        onEntered: onEnterComplete,
        onExited: onCloseComplete,
        shouldAnimate: shouldAnimate
      }, /*#__PURE__*/_react["default"].createElement(_focusTrapReact["default"], {
        active: inProp,
        focusTrapOptions: {
          allowOutsideClick: allowClicksOutsideFocusTrap,
          clickOutsideDeactivates: shouldCloseOnOverlayClick,
          escapeDeactivates: shouldCloseOnEscapePress
        }
      }, /*#__PURE__*/_react["default"].createElement(_ModalContent["default"], props)), /*#__PURE__*/_react["default"].createElement(_ScrollLock["default"], null))));
    }
  }]);

  return Modal;
}(_react["default"].PureComponent);

_defineProperty(Modal, "contextType", _designLanguage.ThemingContext);

_defineProperty(Modal, "propTypes", {
  "in": _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  onEnterComplete: _propTypes["default"].func,
  onCloseComplete: _propTypes["default"].func,
  shouldCloseOnEscapePress: _propTypes["default"].bool,
  shouldCloseOnOverlayClick: _propTypes["default"].bool,
  shouldAnimate: _propTypes["default"].bool
});

_defineProperty(Modal, "defaultProps", {
  shouldCloseOnOverlayClick: true
});

var RenderedModal = (0, _componentLayerManager.renderOnLayer)(_componentLayerManager.Layers.Modal, Modal, {
  AnimationType: _componentLayerManager.AnimationTypes.Custom
});
RenderedModal.HeaderAlignment = _ModalContent["default"].HeaderAlignment;
RenderedModal.Sizes = _ModalContent["default"].Sizes;
RenderedModal.CloseButtonSides = _ModalContent["default"].CloseButtonSides;
RenderedModal.defaultProps = _objectSpread(_objectSpread({}, _ModalContent["default"].defaultProps), {}, {
  shouldAnimate: true,
  shouldCloseOnOverlayClick: true
});
var _default = RenderedModal;
exports["default"] = _default;